<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M82.0589 71.7115C81.4471 70.2426 80.246 68.4071 78.5262 67.0397C75.9267 64.976 72.332 63.4253 72.332 63.4253C72.332 63.4253 73.1666 65.802 73.9419 71.3901C74.9118 78.3765 74.4776 81.038 75.2332 85.033C75.2332 85.033 75.5067 86.8093 76.5301 88.7321C76.9615 89.5412 77.624 90.3842 78.1033 90.3842C78.8617 90.3842 79.3044 89.5271 79.5356 88.8646C80.6041 85.8225 80.1304 84.0745 81.777 80.4685C83.2656 77.2093 82.9865 73.95 82.0561 71.7143L82.0589 71.7115Z"
            class="primary-fill" />
        <path
            d="M81.5612 41.3155C81.268 38.0817 79.7229 35.4343 79.7229 35.4343C79.7229 35.4343 74.7975 32.6403 69.5788 34.3319C64.3601 36.0236 62.5219 44.1096 63.1111 48.3725C63.2944 49.7089 63.644 50.8366 64.1064 51.8206C63.8103 54.1635 63.2324 58.5504 62.9645 59.0326L62.598 59.6951L60.7598 60.9441C60.7598 60.9441 64.2896 65.9429 68.6258 66.752C72.9621 67.5612 72.5955 64.9871 72.5955 64.9871L71.933 63.5915L72.511 58.5927C74.8426 58.9564 77.3716 58.4518 78.9166 56.388C81.564 52.8581 81.8572 44.5522 81.564 41.3184L81.5612 41.3155Z"
            fill="white"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M64.8722 44.7355C64.8722 44.7355 66.4906 43.963 67.6296 41.7949C68.7686 39.6268 68.622 37.6786 68.622 37.6786C68.622 37.6786 70.6802 37.3487 73.7674 38.2679C76.8546 39.187 80.5311 40.436 83.6183 38.671C86.7055 36.9061 86.7055 34.0754 85.2 32.8998C83.5112 31.5831 80.1646 32.3838 80.1646 32.3838C80.1646 32.3838 81.4502 31.1348 80.7538 30.399C80.0546 29.6631 77.52 30.6189 77.52 30.6189C77.52 30.6189 74.4328 28.1576 68.5882 28.4508C62.7436 28.744 59.9496 32.8236 59.6197 37.3826C59.2899 41.9415 60.942 46.4976 60.942 46.4976L64.8751 44.7327L64.8722 44.7355Z"
            class="primary-fill" />
        <path
            d="M62.8153 49.602C62.8153 49.602 63.179 51.0089 65.2682 52.6441C67.3573 54.2793 70.3825 55.4748 70.3825 55.4748L70.625 54.4147C70.625 54.4147 67.4927 53.0529 66.0379 51.553C64.5859 50.0559 64.4026 49.2383 64.4026 49.2383L62.8125 49.602H62.8153Z"
            fill="white"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M70.9889 53.6307C72.6693 53.5517 73.6081 54.8825 73.7237 55.7424C73.8421 56.6023 73.033 57.5665 71.144 56.7207C68.7983 55.6691 69.3057 53.7096 70.9889 53.6335V53.6307Z"
            fill="white"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M77.2987 30.3622C77.2987 30.3622 77.2311 29.6743 75.5338 29.0033C74.5527 28.6142 73.1824 28.7467 73.1824 28.7467C73.1824 28.7467 68.7363 29.1132 64.9865 33.269C62.8466 35.6401 61.7978 38.3777 61.2903 40.2949C58.0649 40.9518 56.2746 44.0221 56.1139 47.1122C55.9109 50.9607 58.7077 53.8872 62.4434 53.594C70.5943 52.9568 69.9373 41.9866 64.4424 40.3964C64.9273 38.9444 65.7985 37.0329 67.304 35.5076C72.706 30.0295 77.3016 30.3622 77.3016 30.3622H77.2987Z"
            fill="white"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M67.388 86.7415C67.0497 83.1524 66.638 79.5295 66.1644 76.8934C64.6194 68.2914 60.7258 60.6481 60.7258 60.6481C60.7258 60.6481 57.3735 61.4742 53.7591 62.9487C49.4736 64.6967 47.8835 69.9492 50.5027 73.7695L60.9852 89.0562C63.0377 92.0475 67.7291 90.3531 67.3908 86.7415H67.388Z"
            class="primary-fill" />
        <path
            d="M77.5699 46.3284C77.3867 47.1573 77.4854 47.7747 77.6066 48.1835C77.7617 48.7079 77.9928 49.0124 77.9816 49.5566C77.9703 50.0528 77.7673 50.4531 77.6038 50.7069"
            fill="white" />
        <path
            d="M77.5699 46.3284C77.3867 47.1573 77.4854 47.7747 77.6066 48.1835C77.7617 48.7079 77.9928 49.0124 77.9816 49.5566C77.9703 50.0528 77.7673 50.4531 77.6038 50.7069"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M58.9043 46.8783C58.9043 44.6876 60.4972 42.9114 62.4595 42.9114C64.4218 42.9114 66.0148 44.6876 66.0148 46.8783C66.0148 49.0689 64.4218 50.8451 62.4595 50.8451"
            fill="white" />
        <path
            d="M58.9043 46.8783C58.9043 44.6876 60.4972 42.9114 62.4595 42.9114C64.4218 42.9114 66.0148 44.6876 66.0148 46.8783C66.0148 49.0689 64.4218 50.8451 62.4595 50.8451"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.3645 62.2523L85.9932 61.0654C86.0383 60.9808 86.0609 60.8877 86.0581 60.7919L85.8748 48.9618C85.8692 48.6657 86.0919 48.4204 86.3682 48.4148L109.264 48.973C109.541 48.9702 109.766 49.2042 109.772 49.5003L109.947 59.5852C109.952 59.8756 109.741 60.1152 109.47 60.1293L88.807 61.2402C88.7224 61.2458 88.6406 61.2712 88.5701 61.3191L86.0581 62.9713C85.6182 63.2617 85.1051 62.7316 85.3617 62.2495L85.3645 62.2523Z"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M72.9722 25.0392L72.741 16.8545C72.6818 14.7569 70.9704 13.085 68.87 13.0765L29.8046 12.9102C27.5801 12.9017 25.8011 14.7541 25.9026 16.9757L29.6693 99.6485C29.7482 101.397 31.1861 102.775 32.9341 102.781L69.6143 102.905"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M32.936 102.778C31.1852 102.772 29.7501 101.394 29.6712 99.6457L25.9045 16.9729C25.8058 14.8302 27.4608 13.0342 29.5725 12.9187L26.9843 12.9074C24.7598 12.8989 22.9808 14.7513 23.0823 16.9729L26.849 99.6457C26.9279 101.394 28.3658 102.772 30.1138 102.778L66.794 102.902V102.894L32.9332 102.778H32.936Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M42.5647 12.958C42.5647 12.958 42.4293 15.5744 49.1084 15.5744C55.7876 15.5744 56.0554 13.1667 56.0554 13.1667L42.5647 12.9552V12.958Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.3047 29.6095C85.8122 29.7279 86.7003 30.0155 87.5292 30.7626C89.1109 32.1836 89.249 34.16 89.2687 34.5857"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M85.168 26.8154C86.0166 27.0523 87.8126 27.681 89.397 29.367C91.5539 31.6591 91.8668 34.3657 91.9317 35.1918"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.6556 84.5338L58.384 83.9135C58.1782 83.8148 58.0485 83.6062 58.0513 83.3806C58.057 83.141 58.0513 82.9042 58.0344 82.6673C58.0203 82.4418 58.1387 82.2303 58.3389 82.1176L59.5738 81.4325C59.8163 81.2971 59.9347 81.0152 59.8557 80.7502L59.5343 79.6732C59.4554 79.4081 59.2016 79.2333 58.9225 79.2531L57.5072 79.3461C57.2788 79.3602 57.0617 79.2446 56.949 79.0473C56.8334 78.8414 56.7093 78.6413 56.5768 78.4467C56.4499 78.2578 56.4443 78.0125 56.5599 77.818L57.2873 76.6113C57.4311 76.3745 57.3888 76.07 57.1858 75.8811L56.3625 75.1086C56.1595 74.9197 55.8522 74.8915 55.621 75.0466L54.4453 75.8275C54.2536 75.9544 54.0083 75.96 53.811 75.8444C53.608 75.7232 53.3994 75.6133 53.1851 75.5089C52.9793 75.4103 52.8496 75.1988 52.8524 74.9704L52.8721 73.5664C52.875 73.2901 52.6861 73.0476 52.4154 72.9828L51.313 72.7206C51.0424 72.6557 50.7632 72.7854 50.6392 73.0335L50.0133 74.2938C49.9118 74.4968 49.7031 74.6265 49.4748 74.6236C49.2323 74.6208 48.9927 74.6236 48.7558 74.6406C48.5275 74.6547 48.3132 74.5363 48.2032 74.3389L47.5125 73.1153C47.3772 72.8756 47.0896 72.76 46.8246 72.8362L45.7363 73.1547C45.4684 73.2337 45.2936 73.4846 45.3105 73.7609L45.4036 75.1621C45.4177 75.3877 45.3021 75.6048 45.1047 75.7147C44.8961 75.8303 44.6903 75.9544 44.4929 76.0869C44.304 76.2138 44.0559 76.2166 43.8614 76.101L42.6434 75.3821C42.4038 75.2411 42.0993 75.2834 41.9075 75.4836L41.1266 76.2984C40.9349 76.4985 40.9095 76.803 41.0646 77.0342L41.8512 78.1986C41.978 78.3875 41.9865 78.6328 41.8681 78.8273C41.7468 79.0275 41.6341 79.2362 41.5298 79.4476C41.4283 79.6534 41.2168 79.7803 40.9884 79.7775L39.5731 79.7577C39.294 79.7549 39.0515 79.941 38.9867 80.2117L38.7216 81.3056C38.6568 81.5734 38.7865 81.8525 39.0374 81.9738L40.309 82.594C40.5148 82.6927 40.6445 82.9014 40.6416 83.1269C40.636 83.3666 40.6416 83.6034 40.6586 83.8402C40.6727 84.0658 40.5542 84.2772 40.3541 84.39L39.1192 85.0751C38.8767 85.2104 38.7583 85.4924 38.8372 85.7574L39.1587 86.8344C39.2376 87.0994 39.4913 87.2742 39.7705 87.2545L41.1858 87.1614C41.4142 87.1473 41.6313 87.2601 41.7412 87.4575C41.8568 87.6661 41.9837 87.8663 42.1162 88.0637C42.2431 88.2525 42.2459 88.495 42.1303 88.6896L41.4029 89.8962C41.2591 90.1331 41.3014 90.4376 41.5044 90.6265L42.3276 91.399C42.5306 91.5879 42.8379 91.6161 43.0691 91.461L44.2448 90.68C44.4365 90.5532 44.6818 90.5475 44.8792 90.6631C45.0822 90.7844 45.2908 90.8943 45.5051 90.9986C45.7109 91.0973 45.8406 91.3088 45.8378 91.5371L45.818 92.9412C45.8152 93.2175 46.0041 93.4599 46.2748 93.5248L47.3772 93.787C47.6478 93.8518 47.9269 93.7222 48.051 93.474L48.6769 92.2138C48.7784 92.0108 48.987 91.8811 49.2154 91.8839C49.4579 91.8867 49.6975 91.8839 49.9343 91.867C50.1627 91.8529 50.377 91.9713 50.4869 92.1687L51.1777 93.3923C51.313 93.6319 51.6006 93.7475 51.8656 93.6714L52.9539 93.3528C53.2217 93.2739 53.3965 93.0229 53.3796 92.7466L53.2866 91.3454C53.2725 91.1199 53.3881 90.9028 53.5883 90.7928C53.7941 90.6772 53.9971 90.556 54.1944 90.4235C54.3861 90.2966 54.6314 90.291 54.8288 90.4066L56.0468 91.1255C56.2864 91.2665 56.5909 91.2242 56.7826 91.024L57.5636 90.2092C57.7553 90.009 57.7807 89.7045 57.6256 89.4733L56.839 88.3089C56.7121 88.12 56.7037 87.8747 56.8221 87.6802C56.9433 87.48 57.0561 87.2714 57.1604 87.06C57.2619 86.8541 57.4734 86.7273 57.7017 86.7301L59.1171 86.7498C59.3962 86.7526 59.6387 86.5666 59.7035 86.2959L59.9685 85.202C60.0334 84.9341 59.9037 84.655 59.6527 84.5338H59.6556ZM49.4466 88.0749C46.7597 88.1313 44.5324 86.0196 44.476 83.3553C44.4196 80.691 46.5511 78.4862 49.2408 78.427C51.9305 78.3706 54.155 80.4823 54.2113 83.1466C54.2677 85.811 52.1363 88.0157 49.4466 88.0749Z"
            fill="white"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M35.6562 23.6492L64.163 23.7027"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M35.7793 26.9704L62.5099 26.7985"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M35.7754 49.0632L52.3505 48.9279"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M35.7793 51.9192L46.648 51.781"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M89.2344 52.1448L106.576 52.1701"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M89.3027 54.933L102.413 54.8428"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M89.3008 57.5975L96.6425 57.4622"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M28.6094 25.2365L31.2962 96.6853C31.2962 100.418 34.0085 103.443 37.3579 103.443H66.2566C67.28 103.443 68.2443 103.161 69.0873 102.662C73.088 100.303 70.2347 94.2352 65.9747 95.9748C64.892 96.4174 64.331 97.2294 64.0039 98.1288C62.0557 103.477 71.3174 116.376 77.4044 114.989C85.6455 113.114 80.8159 89.4564 88.744 88.0495C95.4062 86.8682 96.2436 103.221 99.0517 102.755C101.059 102.423 102.917 94.9372 100.87 75.6611"
            class="accent-stroke"
            stroke-width="5.63877"
            stroke-miterlimit="10" />
        <path
            d="M37.5527 35.1155L43.2 32.4794L49.521 31.9437L43.792 34.5686L37.5527 35.1155Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.5221 31.9437L51.8312 40.6697L46.1304 43.365L39.8347 43.9148L39.2539 41.7411"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M43.793 34.5685L46.1302 43.365"
            class="primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M39.8926 34.0613L46.1516 33.5171L46.4054 34.425L47.55 33.9118L47.3047 32.9532L41.1134 33.4889L39.8926 34.0613Z"
            class="primary-fill primary-stroke"
            stroke-width="0.986784"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
